"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MfaReminder;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const ThemeContext_1 = require("../ThemeContext");
const react_1 = __importDefault(require("react"));
const UserContext_1 = require("../contexts/UserContext");
const PlatformModal_1 = __importDefault(require("../components/PlatformModal"));
const Meta_1 = __importDefault(require("../api/Meta"));
const cancelable_promise_1 = require("cancelable-promise");
const Loading_1 = __importDefault(require("../components/Loading"));
const Helper_1 = require("../Helper");
const lottie_react_native_1 = __importDefault(require("lottie-react-native"));
const Button_1 = __importDefault(require("../components/Button"));
const Authentication_1 = __importDefault(require("../shared/Authentication"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
;
function MfaReminder(props) {
    const [visible, setVisible] = react_1.default.useState(false);
    const [status, setStatus] = react_1.default.useState('loading');
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const mfaEnrollmentRef = react_1.default.useRef(null);
    const [ignored, setIgnored] = react_1.default.useState(false);
    const navigateToMfaSetup = () => {
        ignoreMfaReminder();
        props.navigation.navigate('MultiFactorAuth');
    };
    const ignoreMfaReminder = react_1.default.useCallback(() => {
        if (ignored) {
            return;
        }
        setStatus('saving');
        promise.current?.cancel();
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => Meta_1.default.updateMfaReminder(token))).catch(() => {
            console.error('Failed to update MFA reminder status');
        }).finally(() => {
            setIgnored(true);
            setVisible(false);
            setStatus('done');
        });
    }, []);
    react_1.default.useEffect(() => {
        setStatus('loading');
        var methods = Authentication_1.default.MfaGetStatus();
        if (methods?.length > 0)
            return;
        promise.current?.cancel();
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => {
            Meta_1.default.getMfaReminderStatus(token).then((data) => {
                setVisible(data?.ignoreMfaReminder == false);
            });
        }).catch(() => {
            console.error('Failed to fetch MFA reminder status');
        }).finally(() => {
            setStatus('done');
        }));
    }, []);
    return ((0, jsx_runtime_1.jsx)(PlatformModal_1.default, { isVisible: visible, onDismiss: () => status == 'done' ? ignoreMfaReminder() : console.debug('Not loaded'), children: status === 'saving' &&
            (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 20, alignItems: 'center', justifyContent: 'center', flex: 1 }, children: [(0, jsx_runtime_1.jsx)(Loading_1.default, {}), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: {
                            color: (props.disabled ? THEME.TextDisabled : THEME.TextLight),
                            marginLeft: 10,
                            fontSize: (size != 'sm' ? 16 : 14),
                        }, children: t('login:messages.mfaReminderSaving') })] })
            ||
                (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: 24, fontWeight: '500' }, children: t('login:messages.mfaNotRegistered') }) }), Helper_1.Helper.isPlatformWeb &&
                            (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: -30, marginBottom: -30 }, children: (0, jsx_runtime_1.jsx)(lottie_react_native_1.default, { ref: mfaEnrollmentRef, source: require('../animations/mfa_enrollment.json'), autoPlay: true, loop: true, onAnimationFinish: () => mfaEnrollmentRef.current?.resume(), style: [{ zIndex: 100000, height: '100%', width: '100%' }], resizeMode: 'cover' }) })
                            ||
                                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { height: 150, width: 150 }, children: (0, jsx_runtime_1.jsx)(lottie_react_native_1.default, { ref: mfaEnrollmentRef, source: require('../animations/mfa_enrollment.json'), autoPlay: true, loop: true, onAnimationFinish: () => mfaEnrollmentRef.current?.resume(), style: [{ zIndex: 100000, height: '100%', width: '100%' }], resizeMode: 'cover' }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 6, marginBottom: size != 'sm' ? 0 : 12, marginHorizontal: -6 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { color: THEME.Primary, type: 'solid', text: t('login:buttons.mfaNotRegisteredAction'), onPress: () => navigateToMfaSetup() }) }) })] }) }));
}
